module.exports = __webpack_public_path__ + "img/empty.784376cd.svg";